module.exports = __webpack_public_path__ + "img/1246785594.ed5a32a9.jpg";